import { UITableSortDirections } from '../constants/SortDirections';
const reA = /[^a-zA-Z]/g;
const reN = /[^0-9]/g;
export const alphanumericSort = (a, b) => {
  const aA = a.replace(reA, '');
  const bA = b.replace(reA, '');
  if (aA === bA) {
    const aN = parseInt(a.replace(reN, ''), 10);
    const bN = parseInt(b.replace(reN, ''), 10);
    if (aN === bN) {
      return 0;
    } else if (aN > bN) {
      return 1;
    }
    return -1;
  }
  return aA > bA ? 1 : -1;
};
export const sortByField = (field, UITableSortDir = 'ascending') => {
  const sortDir = UITableSortDirections[UITableSortDir];
  return (a, b) => {
    return alphanumericSort(a.get(field).toLowerCase(), b.get(field).toLowerCase()) * sortDir;
  };
};
export const sortByNumericalField = (field, UITableSortDir = 'ascending') => {
  const sortDir = UITableSortDirections[UITableSortDir];
  return (a, b) => {
    if (isNaN(a.get(field)) && !isNaN(b.get(field))) {
      return -1 * sortDir;
    } else if (!isNaN(a.get(field)) && isNaN(b.get(field))) {
      return Number(sortDir);
    } else if (isNaN(a.get(field)) && isNaN(b.get(field))) {
      return 0;
    } else if (a.get(field) < b.get(field)) {
      return -1 * sortDir;
    } else if (a.get(field) > b.get(field)) {
      return Number(sortDir);
    }
    return 0;
  };
};